import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import TrustBadges from './components/TrustBadges';
import WhyChooseUs from './components/WhyChooseUs';
import AreasCovered from './components/AreasCovered';
import Testimonials from './components/Testimonials';
import BlogPreview from './components/BlogPreview';
import CTABanner from './components/CTABanner';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
const PHONE = '07760 881212';
const LOGO_URL = 'https://public.readdy.ai/ai/img_res/61506c12-fa2c-4fe8-b258-8fe53ec29be1.png';
const HOME_OG_IMAGE = 'https://public.readdy.ai/ai/img_res/03c035e8deac09cab005d08323a9c71a.jpg';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Electrician',
    '@id': `${siteUrl}/#business`,
    name: 'Dukeries Electrical',
    url: siteUrl,
    telephone: '07760 881212',
    email: 'ryan.hopson@hotmail.co.uk',
    logo: {
      '@type': 'ImageObject',
      url: LOGO_URL,
    },
    image: HOME_OG_IMAGE,
    description:
      'Dukeries Electrical — professional local electrician in Worksop offering rewiring, fuse board upgrades, EICR certificates and domestic electrical services.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Worksop',
      addressLocality: 'Worksop',
      addressRegion: 'Nottinghamshire',
      postalCode: 'S80',
      addressCountry: 'GB',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 53.3036,
      longitude: -1.1232,
    },
    areaServed: [
      { '@type': 'City', name: 'Worksop' },
      { '@type': 'City', name: 'Retford' },
      { '@type': 'Place', name: 'Carlton in Lindrick' },
      { '@type': 'Place', name: 'Shireoaks' },
    ],
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59',
    },
    priceRange: '££',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Electrical Services Worksop',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Emergency Electrician Worksop' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'House Rewiring Worksop' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Fuse Board Upgrade Worksop' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'EICR Certificate Worksop' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Domestic Electrician Worksop' } },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    url: siteUrl,
    name: 'Dukeries Electrical | Electrician Worksop',
    description:
      'Dukeries Electrical — professional local electrician in Worksop — rewiring, EICR certificates, fuse board upgrades.',
    inLanguage: 'en-GB',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/#webpage`,
    url: `${siteUrl}/`,
    name: 'Electrician Worksop | Electrical Services Worksop | Local & Trusted',
    description:
      'Professional electrician in Worksop offering rewiring, fuse board upgrades, EICR certificates and domestic electrical services. Fully insured and NAPIT registered.',
    isPartOf: { '@id': `${siteUrl}/#website` },
    about: { '@id': `${siteUrl}/#business` },
    inLanguage: 'en-GB',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Home', item: `${siteUrl}/` }],
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Electrician Worksop | Electrical Services | Rewiring, EICR & More"
        description="Professional electrician in Worksop offering rewiring, fuse board upgrades, EICR certificates &amp; domestic electrical services. Fully insured &amp; NAPIT registered. Call now."
        keywords="electrician Worksop, rewiring Worksop, EICR Worksop, fuse board upgrade Worksop, domestic electrician Worksop"
        canonical={`${siteUrl}/`}
        ogTitle="Electrician Worksop | Electrical Services | Rewiring, EICR & More"
        ogDescription="Professional electrician in Worksop offering rewiring, fuse board upgrades, EICR certificates &amp; domestic electrical services. Fully insured &amp; NAPIT registered. Call now."
        ogUrl={`${siteUrl}/`}
        ogImage={HOME_OG_IMAGE}
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBadges />
        <ServicesOverview />
        <WhyChooseUs />
        <AreasCovered />
        <Testimonials />
        <BlogPreview />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}
